/** Which views the board on screen offers — the switcher's list, and the pinned
 *  pills', so a pin never leads somewhere the switcher would not. */
import { computed, type ComputedRef } from "vue";
import { useBoard } from "../stores/board.js";
import { VIEWS, type View } from "../stores/viewport.js";

/** `board.offersView()` over the switcher's list, in its order. */
export function useOfferedViews(): ComputedRef<Exclude<View, "profile">[]> {
  const board = useBoard();
  return computed(() => VIEWS.filter((v) => board.offersView(v)));
}
